import React from "react";
import { TextField, useTheme } from "@mui/material";

const FormTextField = ({ label, ...props }) => {
  const theme = useTheme();
  return (
    <TextField
      fullWidth
      variant="filled"
      label={label}
      InputProps={{
        disableUnderline: true,
        sx: {
          backgroundColor: theme.palette.custom.white,
          borderRadius: 2,
          px: 2,
          mb: 2,
          "&:hover": {
            backgroundColor: theme.palette.custom.hover_white,
          },
          "&.Mui-focused": {
            backgroundColor: theme.palette.custom.white,
          },
        },
      }}
      InputLabelProps={{
        sx: {
          fontWeight: "bold",
          color: theme.palette.text.primary,
        },
      }}
      {...props}
    />
  );
};

export default FormTextField;
